import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { authClient } from "../lib/auth";

export function InvitePage({ onAccepted }: { onAccepted: () => void }) {
  const { id } = useParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("Joining the team…");
  useEffect(() => {
    authClient.organization.acceptInvitation({ invitationId: id! }).then(res => {
      if (res.error) { setStatus(res.error.message || "This invitation can't be used. Ask for a new link, and check you're signed in with the invited email."); return; }
      onAccepted();
      nav("/");
    });
  }, [id]);
  return <p className="muted">{status}</p>;
}
